import { SidebarNavItem } from 'components/common/sidebar-nav-item';
import { Badge } from 'design-system/badge/badge';
import { type ComponentProps } from 'react';

import { GET_STARTED_STEPS } from '../get-started-steps';

interface GetStartedNavItemProps {
  /** The navigating element, supplied by the owner that knows the route. */
  render: ComponentProps<typeof SidebarNavItem>['render'];
  isActive: boolean;
  collapsed: boolean;
  completedCount?: number;
}

export const GetStartedNavItem = ({
  render,
  isActive,
  collapsed,
  completedCount,
}: GetStartedNavItemProps) => (
  <SidebarNavItem
    label="Get started"
    render={render}
    isActive={isActive}
    collapsed={collapsed}
    leading={
      <svg
        aria-hidden="true"
        viewBox="0 0 16 16"
        className="text-foreground-secondary size-4 shrink-0 -rotate-90"
        fill="none"
      >
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-fill-secondary"
        />
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="1.5"
          pathLength="1"
          strokeDasharray={`${(completedCount ?? 0) / GET_STARTED_STEPS.length} 1`}
        />
      </svg>
    }
    trailing={
      completedCount !== undefined && !collapsed ? (
        <Badge variant="secondary">
          {completedCount}/{GET_STARTED_STEPS.length}
        </Badge>
      ) : undefined
    }
  />
);
GetStartedNavItem.displayName = 'GetStartedNavItem';
